import React from 'react';

// Add additional tags here
const ALLOWED_TAGS = new Set(['strong', 'b', 'em', 'i', 'a', 'br']);

function sanitizeUrl(href) {
  try {
    const u = new URL(href, typeof window !== 'undefined' ? window.location.href : 'http://localhost');
    const safeProtocols = new Set(['http:', 'https:', 'mailto:', 'tel:']);
    return safeProtocols.has(u.protocol) ? u.toString() : '#';
  } catch {
    return '#';
  }
}

function renderNode(node, keyPrefix, index) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  }

  if (node.nodeType === Node.ELEMENT_NODE) {
    const el = node;
    const tag = el.tagName.toLowerCase();
    const children = Array.from(el.childNodes).map((n, i) => renderNode(n, `${keyPrefix}-${index}`, i));

    if (!ALLOWED_TAGS.has(tag)) {
      // Strip disallowed tags but render inner content
      return <React.Fragment key={`${keyPrefix}-${index}`}>{children}</React.Fragment>;
    }

    switch (tag) {
      case 'strong':
      case 'b':
        return <strong key={`${keyPrefix}-${index}`}>{children}</strong>;
      case 'em':
      case 'i':
        return <em key={`${keyPrefix}-${index}`}>{children}</em>;
      case 'br':
        return <br key={`${keyPrefix}-${index}`} />;
      case 'a': {
        const href = sanitizeUrl(el.getAttribute('href') || '#');
        return (
          <a key={`${keyPrefix}-${index}`} href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        );
      }
      default:
        return <React.Fragment key={`${keyPrefix}-${index}`}>{children}</React.Fragment>;
    }
  }

  return null;
}

function renderSafeHtml(html) {
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const body = doc.body;
  return Array.from(body.childNodes).map((n, i) => renderNode(n, 'n', i));
}

export default function MessageError({ error, className = '', isHtml = false }) {
  if (!error) return null;

  if (!isHtml) {
    return <p className={`color-error ${className}`}>{error}</p>;
  }

  return <p className={`color-error ${className}`}>{renderSafeHtml(error)}</p>;
}
